import { AppError } from '@app/domain/entities';

/**
 * Thrown when a WebAuthn operation (credential creation, assertion, or PRF
 * extraction) fails. `operation` is a human-readable description of the step
 * that failed, e.g. `'credential creation'` or `'PRF extraction'`.
 */
export class WebAuthnError extends AppError {
  readonly code = 'E_WEBAUTHN';

  constructor(
    public readonly operation: string,
    cause?: unknown,
  ) {
    super(`WebAuthn ${operation} failed`, { operation }, { cause });
  }
}
